import {z} from "zod/v4-mini"
import {graphNode} from "@cm/graph-v3"
import {externalId} from "#template/nodes/validation"
import {MetaData} from "#template/nodes/meta-data"

export const inputNodeParameters = <ItemType>(itemSchema: z.ZodMiniType<ItemType, ItemType>) =>
    z.object({
        name: z.string(),
        id: externalId,
        default: z.optional(itemSchema),
        metaData: z.optional(graphNode(MetaData)),
    })
